import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Grid, Col, Button, Row, Glyphicon, Label } from '@bingads-webui-react/primitive';

export default class SourceCategory extends PureComponent {
  static defaultProps = {
    disabled: false,
    isShow: true,
  }

  render() {
    const { disabled, isShow } = this.props;
    const ariaLabel = `${this.props.i18n.getString('DoubleListBox_Add')} ${this.props.title} ${this.props.body}`;

    return (
      <React.Fragment>
        {
          isShow &&
          <Button
            className={`source-category ${this.props.className}`}
            block
            onClick={() => this.props.onChange(this.props.category)}
            disabled={disabled}
            aria-label={ariaLabel}
          >
            <Grid fluid>
              <Row>
                <Col sm={11}>
                  <Label className="category-title">{this.props.title}</Label>
                  <div className="category-description">{this.props.body}</div>
                </Col>
                <Col sm={1}>
                  <Glyphicon className="category-action" glyph="chevron-right" />
                </Col>
              </Row>
            </Grid>
          </Button>
        }
      </React.Fragment>
    );
  }
}

SourceCategory.propTypes = {
  onChange: PropTypes.func.isRequired,
  category: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isShow: PropTypes.bool,
};
